export default __webpack_public_path__ + "static/media/3.8fab229a.png";